import { AfterViewInit, Component, OnDestroy } from '@angular/core'
import { FormControl } from '@angular/forms'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { Subject } from 'rxjs'
import { takeUntil, tap } from 'rxjs/operators'
import {
  SessionAction,
  SessionModalResponse,
} from '../../../models/session-action.model'

@Component({
  selector: 'hs-uncommitted-changes-detected-modal',
  templateUrl: './uncommitted-changes-detected-modal.component.html',
  styleUrls: ['./uncommitted-changes-detected-modal.component.scss'],
})
export class UncommittedChangesDetectedModalComponent
  implements AfterViewInit, OnDestroy
{
  /**
   * Account ID for the session that the user is closing.
   */
  accountIds: number[] = []
  /**
   * Number of commands that the session has.
   */
  changes: number | null = null
  action: SessionAction | null = null

  /** @internal **/
  DISCARD = SessionAction.DISCARD
  /** @internal **/
  RUN_WITH_ETLS = SessionAction.RUN_WITH_ETLS
  /** @internal **/
  RUN_WITHOUT_ETLS = SessionAction.RUN_WITHOUT_ETLS

  radioInline: FormControl = new FormControl(null)

  private readonly destroySubject = new Subject<void>()

  constructor(public activeModal: NgbActiveModal) {}

  ngAfterViewInit() {
    this.radioInline.valueChanges
      .pipe(
        takeUntil(this.destroySubject),
        tap(newVal => (this.action = newVal)),
      )
      .subscribe()
  }

  ngOnDestroy() {
    this.destroySubject.next()
    this.destroySubject.complete()
  }

  submit() {
    if (this.action != null)
      this.activeModal.close({
        action: this.action,
      } as SessionModalResponse)
  }
}
